import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6988abdcb7c6670013a7b9fd/lenormand_tarot_reading/src/app/HomePage.tsx");
